'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Each module item on the moduleLanding page
 * This is a picture/image with heading
 */
var ModuleItem = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData.data, userIsAdmin: state.userCredential };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ModuleItem, _Component);

  function ModuleItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModuleItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModuleItem.__proto__ || (0, _getPrototypeOf2.default)(ModuleItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showItem: false
    }, _this.mouseOver = function (module, event) {
      event.preventDefault();
      var obj = _this.state;
      obj.showItem = true;
      _this.setState(obj);
    }, _this.mouseExit = function (module, event) {
      event.preventDefault();
      var obj = _this.state;
      obj.showItem = false;
      _this.setState(obj);
    }, _this.calcProgressOfModule = function () {
      // let moduleData = this.props.app;
      // let key = '';
      // for (key in this.props.app) {
      //   if (key === this.props.moduleID) {
      //     moduleData = this.props.app[key];
      //     break;
      //   }
      // }

      // let totalNum = 0;
      // let numCompleted = 0;
      // for (key in moduleData) {
      //   // get first 3 letters, to know if app or not
      //   if (key.substring(0, 3) === 'app') {
      //     if (moduleData[key].isCompleted === true) {
      //       numCompleted++;
      //     }
      //     totalNum++;
      //   }
      // }
      // return (numCompleted / totalNum) * 100;

      var numAppCompleted = _this.props.app[_this.props.moduleID].numAppCompleted;
      var numAppTotal = _this.props.app[_this.props.moduleID].numAppTotal;

      return numAppCompleted / numAppTotal * 100;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* ******************* */
  /*  MOUSE OVER EVENTS  */
  /* ******************* */

  // mouse over on a module image


  // mouse exit on a module image


  /* END MOUSE EVENTS */

  (0, _createClass3.default)(ModuleItem, [{
    key: 'render',
    value: function render() {
      var styles = require('../Modules.scss');

      return (
        // remove !this.props.userIsAdmin.isAdmin for each {}, not sure what not admin does though
        // !this.props.userIsAdmin.isAdmin || for first {} and && for second {}
        _react2.default.createElement(
          'div',
          null,
          !this.props.isLocked && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/' + this.props.moduleID, style: { textDecoration: 'none' } },
              _react2.default.createElement(
                'div',
                { className: styles.moduleImg, onMouseOver: this.mouseOver.bind(this, this.props.moduleID),
                  onMouseLeave: this.mouseExit.bind(this, this.props.moduleID) },
                _react2.default.createElement(
                  'h3',
                  null,
                  this.props.moduleTitle
                ),
                _react2.default.createElement(ReactBootstrap.Image, { src: this.props.moduleImg, responsive: true })
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer10 }),
            _react2.default.createElement(ReactBootstrap.ProgressBar, { bsStyle: 'success', now: this.calcProgressOfModule() }),
            this.state.showItem && _react2.default.createElement(
              'div',
              { className: styles.imageOverlay },
              _react2.default.createElement(
                'h3',
                null,
                this.props.moduleDescription
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 })
          ),
          this.props.isLocked && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.moduleImg, onMouseOver: this.mouseOver.bind(this, this.props.moduleID),
                onMouseLeave: this.mouseExit.bind(this, this.props.moduleID) },
              _react2.default.createElement(
                'h3',
                null,
                this.props.moduleTitle
              ),
              _react2.default.createElement(ReactBootstrap.Image, { src: this.props.moduleImg, responsive: true })
            ),
            _react2.default.createElement('div', { className: styles.spacer10 }),
            _react2.default.createElement(ReactBootstrap.ProgressBar, { bsStyle: 'success', now: this.calcProgressOfModule() }),
            this.state.showItem && _react2.default.createElement(
              'div',
              { className: styles.imageOverlay },
              _react2.default.createElement(
                'h3',
                null,
                'Locked'
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 })
          )
        )
      );
    }
  }]);
  return ModuleItem;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  moduleTitle: _propTypes2.default.string, // "Getting Ready", "Module 1" etc...
  moduleImg: _propTypes2.default.string,
  moduleID: _propTypes2.default.string, // key used to index into the object in ModulesLanding 'module1'
  moduleDescription: _propTypes2.default.string, // description which appears on hover
  isLocked: _propTypes2.default.bool, // is this module item locked
  userIsAdmin: _propTypes2.default.object
}, _temp2)) || _class);
/* eslint-enable */

exports.default = ModuleItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ModulesLanding/ModuleItem.js
// module id = 1220
// module chunks = 0